export default __webpack_public_path__ + "a16cc8a19827ebac2692874d04a4e2a2.png";